import { useParamsSearch } from '@anytag/shared-hooks';
import { ListWithPagination } from '@anytag/shared-molecules';
import { useTwitterAnalyticsPostsQuery } from '@anytag/graphql';
import { getOffset, getValuableVariables } from '@anytag/shared-utils';
import { ProfilePostsCount, ProfilePostsFilter, AnalyticsTwitterPostsList } from '@anytag/shared-organisms';
import { useInitialAnalyticsPosts } from '../hooks';
import { AnalyticsTwitterPostsSearchSchemaType } from './schema-types';

export const AnalyticsTwitterPosts = () => {
  const { brandAccountId, mainSocialAccountId } = useInitialAnalyticsPosts({
    socialMedia: 'twitter',
    document: (name) => ({
      alwaysBackToParent: true,
      appHeader: name ? 'appHeader.FeedPostsListWithAccountName' : 'appHeader.Feed Posts List',
      title: name ? 'documentTitle.FeedPostsListWithAccountName' : 'documentTitle.Feed Posts List'
    })
  });
  const { page, limit, sort, filter, setFilter } = useParamsSearch<AnalyticsTwitterPostsSearchSchemaType>();
  const { data, previousData, loading } = useTwitterAnalyticsPostsQuery({
    skip: !brandAccountId || !mainSocialAccountId,
    variables: getValuableVariables({
      limit,
      orderBy: sort,
      offset: getOffset(page, limit),
      twitterAnalyticsAccountId: Number(mainSocialAccountId),
      ...filter
    })
  });

  const result = loading ? previousData : data;
  const totalRecords = result?.twitterAnalyticsPostsCount?.totalNumber;

  return (
    <ListWithPagination pagination={{ totalRecords }}>
      <ProfilePostsFilter filter={filter} setFilter={setFilter} hasPeriod />

      <ProfilePostsCount count={totalRecords} />

      <AnalyticsTwitterPostsList
        loading={loading}
        mainSocialAccountId={mainSocialAccountId}
        data={result?.twitterAnalyticsPosts.posts || []}
      />
    </ListWithPagination>
  );
};
